<template>
  <div class="Tbs">
    <div class="left">
      <div
        v-for="(item,index) in list"
        :key="index"
        class="standard">
        <el-button
          v-for="(val,itemIndex) in item.itemList"
          :key="itemIndex"
          class="bottomBtn"
          size="medium"
          :class="{active:active(item,val)}"
          @click="buttonCli(item,val)">
          {{ val.name }}
        </el-button>
      </div>
    </div>
    <div class="right">
      <el-input
        v-model="search"
        class="rightInput"
        size="small"
        placeholder="请输入内容"
        suffix-icon="el-icon-search"
        @change="searchFn"
      />
      <!-- <el-button type="primary">
        查看全部文库
      </el-button> -->
      <el-tag v-if="categoryName" type="" closable @close="close">
        {{ categoryName }}
      </el-tag>
    </div>
  </div>
</template>

<script>
export default {
  //  单选框
  name: 'Tbs',
  components: {},
  props: {},
  data() {
    return {
      search: '',
      list: {
        category: {
          type: 'category_id',
          itemList: [
            {
              name: '全部',
              id: ''
            },
            {
              name: '国家标准',
              id: 1
            },
            {
              name: '行业标准',
              id: 2
            },
            {
              name: '地方标准',
              id: 3
            },
            {
              name: '团体标准',
              id: 4
            },
            {
              name: '建设指南',
              id: 5
            }
          ]
        },
        type: {
          type: 'type',
          itemList: [
            {
              type: 'type',
              name: '全部',
              id: ''
            },
            {
              name: '建筑工程类',
              id: 1
            },
            {
              name: '教学空间功能类',
              id: 2
            },
            {
              name: '装备配备类',
              id: 3
            },
            {
              name: '教学环境类',
              id: 4
            },
            {
              name: '教育教学类',
              id: 5
            }
          ]
        }
      },
      category_id: '',
      type: ''
    }
  },
  computed: {
    filterData() {
      return {
        search: this.search,
        category_id: this.category_id,
        type: this.type
      }
    },
    categoryName() {
      return this.$route.query.name || ''
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    searchFn() {
      this.$emit('filter', this.filterData)
    },
    active(item, val) {
      return val.id === this[item.type]
    },
    buttonCli(item, val) {
      this[item.type] = val.id
      this.$emit('filter', this.filterData)
    },
    close() {
      this.$router.replace('/notes/standard')
      this.$emit('filter', { category: '', ...this.filterData })
    }
  }
}
</script>

<style lang="scss" scoped>
.Tbs{
  width: 100%;
  height: 100px;

  display: flex;
  .left{
    flex: 1;
    margin-right: 40px;
    .standard{
      margin-bottom: 20px;
      .bottomBtn{
        box-shadow: 0px 3px 3px 0px rgba(85, 85, 85, 0.1);
        border-radius: 8px;
      }
      .bottomActive{
        color: #fff;
        background: $xr-color-primary;
      }
    }
    // .bottomStandard{
    //   margin-top:20px;
    //   .bottomBtn{
    //     box-shadow: 0px 3px 3px 0px rgba(85, 85, 85, 0.1);
    //     border-radius: 8px;
    //   }
    //   .bottomActive{
    //     color: #fff;
    //     background: $xr-color-primary;
    //   }
    // }
  }
  .right{
    flex-shrink: 0;
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .rightInput{
      width: 140px;
      float: right;
      margin-bottom: 20px;
        &:hover{
        width: 300px;
        transition: .1s width;
        }
    }
  }
.el-button + .el-button{
  margin-left: 20px;
}
.active{
  color: #fff;
  background: $xr-color-primary;
}
}
</style>
